export default "__VITE_ASSET__B3zPasd9__"